export default "__VITE_ASSET__35b0d23c__"